__turbopack_context__.v({
  "bundle-unit-container": "course-body-content-module-scss-module__El1ffW__bundle-unit-container",
  "certification-banner-placement-container": "course-body-content-module-scss-module__El1ffW__certification-banner-placement-container",
  "certification-course-unit-placement-container": "course-body-content-module-scss-module__El1ffW__certification-course-unit-placement-container",
  "container": "course-body-content-module-scss-module__El1ffW__container",
});
